<template>
  <div class="custom-container" v-loading.fullscreen.lock="banner.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="banner-title">Edit Banner</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save"
            >Simpan</el-button
          >
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form
          label-position="left"
          ref="banner"
          label-width="120px"
          :model="banner.data"
        >
          <Form :Banner="banner.data"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    Form
  },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      banner: state => state.banner.banner
    })
  },
  methods: {
    ...mapActions({
      getBanner: "banner/GetBanner",
      updateBanner: "banner/UpdateBanner"
    }),
    save() {
      this.$refs.banner.validate(valid => {
        if (valid) {
          this.updateBanner(this.banner.data);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getBanner(this.id);
  }
};
</script>

<style></style>
